/** Canonical manifest for all 8 multichain identity cards.
 *  The images are the primary content — all chain name / status text
 *  is baked into the artwork. The fields here are used for alt text,
 *  compact metadata rows, and status pill colours only.
 */

export type MultichainCard = {
  key: string;
  title: string;
  status: "LIVE TESTNET" | "COMING NEXT" | "PLANNED" | "COMING SOON" | "IN DEVELOPMENT";
  meta: string;
  image: string;
  link: string;
};

export const MULTICHAIN_CARDS: MultichainCard[] = [
  {
    key: "robinhood",
    title: "Robinhood Chain",
    status: "LIVE TESTNET",
    meta: "CHAIN 46630 · EVM · Solidity 0.8.24",
    image: "/assets/synapz-degen/futuristic_robinhood_ui_panel.png",
    link: "/fair-launch",
  },
  {
    key: "synapz",
    title: "SYNAPZ Chain",
    status: "IN DEVELOPMENT",
    meta: "AI-native · Governed execution · Multichain settlement",
    image: "/assets/synapz-degen/futuristic_synapz_chain_card.png",
    link: "/about",
  },
  {
    key: "base",
    title: "Base",
    status: "COMING NEXT",
    meta: "EVM · ETH L2",
    image: "/assets/synapz-degen/base_interface_with_futuristic_neon_glow.png",
    link: "/networks",
  },
  {
    key: "solana",
    title: "Solana",
    status: "PLANNED",
    meta: "SVM · SOL",
    image: "/assets/synapz-degen/futuristic_solana_status_card_design.png",
    link: "/networks",
  },
  {
    key: "ethereum",
    title: "Ethereum",
    status: "COMING SOON",
    meta: "EVM · ETH Mainnet",
    image: "/assets/synapz-degen/futuristic_ethereum_announcement_ui.png",
    link: "/networks",
  },
  {
    key: "xrp",
    title: "XRP",
    status: "COMING SOON",
    meta: "XRPL · XRP Ledger",
    image: "/assets/synapz-degen/futuristic_xrp_digital_card_design.png",
    link: "/networks",
  },
  {
    key: "sui",
    title: "Sui",
    status: "COMING SOON",
    meta: "Move · Parallel execution",
    image: "/assets/synapz-degen/futuristic_sui_tech_card_design.png",
    link: "/networks",
  },
  {
    key: "dogecoin",
    title: "Dogecoin",
    status: "COMING SOON",
    meta: "UTXO · DOGE",
    image: "/assets/synapz-degen/futuristic_dogecoin_announcement_card.png",
    link: "/networks",
  },
];
